import { Button, Modal, Text } from '@fozito/common-ui';
import { Form } from 'antd';
import customerApis from 'modules/customer/services/apis';
import { CreateCustomerBody } from 'modules/customer/services/constants';
import FormCustomer from 'modules/customer/widgets/AddCustomer/Form';
import { ICustomerFormValues, ISearchCustomerItem } from 'modules/customer/widgets/AddCustomer/type';
import { useState } from 'react';
import { IResponseData } from 'services/response';
import styled from 'styled-components';
import { PHONE_MASKED } from 'utils/mask';
import toast from 'utils/toast';
import { setPageLoading } from 'widgets/PageLoading';
import { cashierCtrl } from '../../cashier.controller';
import account_icon from './account.svg';

type Props = {};
const AddNewCustomer = ({ }: Props) => {
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();
  const onOpen = () => setVisible(true);

  const onClose = () => {
    form.resetFields();
    setVisible(false);
  };
  const valid = async () => {
    try {
      await form.validateFields();
      return true;
    } catch (error) {
      return false;
    }
  };
  const onSubmit = async () => {
    if (!(await valid())) return;
    form.submit();
  };

  const handleFinish = async (values: ICustomerFormValues) => {
    PHONE_MASKED.resolve(values?.phone);
    const phone = PHONE_MASKED.unmaskedValue;
    const payload: CreateCustomerBody = {
      phone: phone || '',
      name: values.name || '',
      email: values.email || '',
      dob: values.birthday || '',
    };
    setPageLoading(true);
    try {
      const res: IResponseData<ISearchCustomerItem | null> = await customerApis.customer.create(payload);
      const data = res.data.data;
      if (data) {
        cashierCtrl.chooseCustomer(data);
        onClose();
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message || error?.message || 'Create failed');
    }
    finally {
      setPageLoading(false);
    }
  };

  return (
    <>
      <ButtonContainer type='button' onClick={onOpen}>
        <img src={account_icon} alt="account_icon" style={{ width: 'auto', height: 42 }} />
        <Text content_content_3_16_semibold color_text_1>Add Customer</Text>
      </ButtonContainer>

      <Modal
        width={880}
        open={visible}
        title="ADD NEW CUSTOMER"
        onClose={onClose}
        onOk={onSubmit}
        className='modal-bg-v2 modal-non-opacity'
      >
        <ContainerFormNewAptV2<any> form={form} onFinish={handleFinish} layout='vertical'>
          <FormCustomer />
          <FooterActions>
            <Button onClick={onClose} type_cancel><span>Close</span></Button>
            <Button onClick={() => form.submit()} type_primary><span>Add</span></Button>
          </FooterActions>
        </ContainerFormNewAptV2>
      </Modal>
    </>
  );
};

export default AddNewCustomer;
const ButtonContainer = styled.button`
  display: flex;
  padding: 4px 0px;
  width: 135px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  border-radius: 4px;
  background: #2D6772;
  box-shadow: 0px 2px 4px 0px rgba(44, 35, 66, 0.40), 0px 4px 8px -3px rgba(45, 35, 66, 0.30), 0px -3px 0px 0px #6FABB6 inset;
  &:hover,
  &:active {
    opacity: 0.8;
    transform: scale(1.05);
    transition: all 0.1s;
  }

  &:disabled {
    opacity: 0.7;
    &:hover,
    &:active {
      opacity: 0.7;
      cursor: not-allowed;
      transform: none;
      transition: none;
    }
  }

`;
const ContainerFormNewAptV2 = styled(Form)`
  padding: 16px;
  .ant-form-item-label label {
    color: #1D2129;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  .ant-input, .ant-input-suffix, .InputDOB {
    display: flex;
    height: 56px;
    align-items: center;
    gap: 10px;
    align-self: stretch;
    border-radius: 4px;
    border: 1px solid #CCD4DC;
    background: #FFF;
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  .suggestion {
    .box-item {
      display: flex;
      padding: 8px 24px;
      justify-content: center;
      align-items: center;
      gap: 4px;
      flex: 1 0 0;
      border-radius: 100px;
      border: 1px solid #4384FF;
      background: #FFF;
      .CONTENT_1 {
        color: #4384FF;
        text-align: center;
        font-family: Poppins;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
      }
    }
  }
`;

const FooterActions = styled.div`
  display: flex;
  align-items: center;
  button {
    flex: 1;
  }
  gap: 16px;
`;